import * as img2base64 from 'image-to-base64';

export class ImageUtil {

    public static convertImgToBase641(url) {
        const splits = url.split('.');
        return img2base64(url).then(u => `data:image/${splits[splits.length - 1]};base64, ${u}`);
    }

    public static convertImgToBase64(url) {
        return new Promise((resolve, reject) => {
            try {
                const splits = url.split('.');

                const img = new Image();
                img.setAttribute('crossorigin', 'anonymous');
                img.src = url;

                img.onload = function () {
                    const canvas: any = document.createElement('CANVAS');
                    const ctx = canvas.getContext('2d');
                    canvas.height = img.height;
                    canvas.width = img.width;
                    ctx.drawImage(img, 0, 0);
                    resolve(canvas.toDataURL(`image/${splits[splits.length - 1]}`));
                };

                img.onerror = () => {
                    resolve('');
                };
                img.src = url;
            } catch (e) {
                reject(e);
            }
        });
    }

    public static createImageFromBlob(image: any) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.addEventListener('load', () => {
                resolve(reader.result);
            }, false);

            if (image) {
                reader.readAsDataURL(image);
            }
        });
    }

    public static dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    }

}



// WEBPACK FOOTER //
// ./src/app/models/utils/image.util.ts